import {BookingModel} from "../../booking.model";
import {JourneyModel} from "../../journey/journey.model";
import {BookingMutationActionBase} from "../booking-mutation-action-base";
import {
    IBundleSsrUpgradePair
} from "../../bundle/bundle-ssr-upgrade.model.interface";

import {createJourneySellBundleRequests} from "./sell-bundle.helpers";

export abstract class SellJourneyBundleMutation extends BookingMutationActionBase {
    constructor(booking: BookingModel,
                protected readonly bundleCodeToSell: string) {
        super(booking)
    }


    async onAfterBookingSessionDataUpdated(): Promise<void> {
        this.booking.departureJourney?.onBundleUpdated();
        this.booking.returnJourney?.onBundleUpdated();
        await super.onAfterBookingSessionDataUpdated();
    }


    protected _createJourneySellBundleRequest(journey: JourneyModel, bundleSsrsUpgradesPairs: IBundleSsrUpgradePair[]) {

        return createJourneySellBundleRequests(this.bundleCodeToSell, journey, bundleSsrsUpgradesPairs);
    }


}
